import { ObjectFieldTemplateProps } from "@rjsf/utils/lib/types";
import { useState } from "react";
import { getFirstError, truncateError, processTemplate, getNestedValue } from "./FieldUtils";

function ObjectFieldTemplate(props: ObjectFieldTemplateProps) {
  const uiOptions = (props.uiSchema && props.uiSchema["ui:options"]) || {};

  const isNewItem = false; // TODO detect if new or old
  const initialCollapsed = isNewItem ? false : uiOptions.collapsed || false;
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const renderTitle = () => {
    // Use dynamic title from form data if specified in ui:options
    let displayTitle = props.title;

    if (uiOptions.titleTemplate && props.formData) {
      // Use template with variable substitution
      const processedTitle = processTemplate(uiOptions.titleTemplate as string, props.formData, props.idSchema);
      displayTitle = !!processedTitle ? processedTitle : displayTitle;
    } else if (uiOptions.titleFromField && props.formData) {
      // Use single field value (backward compatibility)
      const nestedValue = getNestedValue(props.formData, uiOptions.titleFromField as string);
      if (nestedValue !== undefined) {
        displayTitle = nestedValue;
      }
    } else if (uiOptions.title) {
      displayTitle = uiOptions.title;
    }

    if (!uiOptions.collapsible) {
      const firstError = getFirstError(props);
      return (
        <div style={{ fontWeight: "bold" }}>
          {displayTitle}
          {firstError && (
            <span style={{ color: "red", marginLeft: "8px", fontWeight: "normal" }}>{truncateError(firstError)}</span>
          )}
        </div>
      );
    }

    return (
      <div
        style={{
          fontWeight: "bold",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: (uiOptions.themeColor as string) || "#5096E8",
          padding: "16px",
        }}
        onClick={toggleCollapse}
      >
        <span style={{ fontSize: "14px", color: "white" }}>{isCollapsed ? "▶" : "▼"}</span>
        <span style={{ color: "white" }}>
          {displayTitle}
          {(() => {
            const firstError = getFirstError(props);
            return (
              firstError && (
                <span
                  style={{
                    marginLeft: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    padding: "2px 6px",
                    borderRadius: "3px",
                    fontSize: "12px",
                    color: "#d32f2f",
                  }}
                >
                  {truncateError(firstError)}
                </span>
              )
            );
          })()}
        </span>
      </div>
    );
  };

  const themeColor = uiOptions.themeColor || "#5096E8";

  return (
    <div style={{ marginBottom: "0px", border: uiOptions.collapsible ? `4px solid ${themeColor}` : "none" }}>
      {renderTitle()}
      {!isCollapsed && (
        <div style={{ padding: "16px" }}>
          {props.description}
          {uiOptions.customObjectLayout === "horizontal" && (
            <div style={{ display: "flex", gap: "16px" }}>
              {props.properties.map(element => (
                <div className="property-wrapper" style={{ flexGrow: 1, marginBottom: 20 }} key={element.content.key}>
                  {element.content}
                </div>
              ))}
            </div>
          )}

          {uiOptions.customObjectLayout !== "horizontal" && (
            <div>
              {props.properties.map(element => (
                <div className="property-wrapper" style={{ marginBottom: 20 }} key={element.content.key}>
                  {element.content}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ObjectFieldTemplate;
